module.exports = __webpack_public_path__ + "assets/normal/images/document.a2fc4aef.png";